export function getQuizzes(constantParams = {}, params = {}) {
  if(process.env.NODE_ENV === 'development') {
    return import('../mock/quizzesData').then((module) => {
      return module.mockData(constantParams['filter[compare]'] === '=' ? 'free' : constantParams['filter[compare]'] === '!=' ? 'nonFree' : 'all').data;
    });
  }

  const columnIndex = {
    id: 0,
    description: 1,
    coach_name: 2,
    cards: 3,
    type: 4,
    stack_chips: 5,
    blind_small: 6,
    position: 7,
    opponent_position: 8,
    access_lbl: 9,
    user_score: 10
  };
  const orderDirShort = {
    ascending: 'asc',
    descending: 'desc'
  };
  const searchParams = new URLSearchParams(constantParams);

  if(params.draw) {
    searchParams.append('draw', params.draw);
  }

  if(params.length) {
    searchParams.append('length', params.length);
  }

  if(params.start) {
    searchParams.append('start', params.start);
  }

  if(params.search) {
    searchParams.append('search[value]', params.search);
  }

  if(params.column) {
    searchParams.append('order[0][column]', columnIndex[params.column]);
  }

  if(params.direction) {
    searchParams.append('order[0][dir]', orderDirShort[params.direction]);
  }

  const wpnonce = window?.dataWP?.config?.wpnonce;

  const wpNonceParam = wpnonce ? `&_wpnonce=${wpnonce}` : '';

  return fetch(`${window.dataWP.config.endpoints.home_url}/wp-json/pokercoaching/v1/get_quizzes?${searchParams.toString()}${wpNonceParam}`, {
    method: 'GET'
  })
    .then((res) => {
      return res.json();
    })
    .then((res) => {
      if(!res.success) {
        throw Error(res.data.message);
      }

      return res.data;
    });
}
